import React from "react";
import MUIDataTable from "mui-datatables";
import { CircularProgress, Box, TextField } from "@mui/material";
import './App.css';
import {utils, write} from "xlsx";
import { saveAs } from 'file-saver'
import {adaptV4Theme, createTheme, ThemeProvider} from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MalzemeListesiOnizleme from "./MalzemeListesiOnizleme";
import ExpandableRowEntry from "./ExpandableRowEntry";
import TeklifSatisRaporuChild from "./TeklifSatisRaporuChild";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import ModalBoxSevkiyatNotu from "./ModalboxSevkiyatNotu";
import ModalboxEkler from "./ModalboxEkler";
import { api } from "./api/client";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";
import { buildPageParams, withServerSideOptions, makeServerTableHandler } from "./utils/serverSideTable";

const teklifTipiLabels = {
    teklif: "Teklif",
    yedek_parca: "Yedek Parça",
    sozlesme: "Bakım Sözleşmesi",
    agir_bakim: "Ağır Bakım",
    agir_tamir: "Ağır Tamir",
    revizyon_guncelleme: "Revizyon-Güncelleme",
};

const teklifTipiLabel = (value) => teklifTipiLabels[value] || value || "";

class TeklifSatisRaporu extends React.Component {
    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const yil = params.get("yil") || new Date().getFullYear().toString();
        const ay = params.get("ay") ;

        const temsilci = params.get("temsilci") || "";
        const teklifTipi = params.get("teklif_tipi") || "";

        this.state = {
            veriler: [],
            count: 0,
            page: 0,
            rowsPerPage: 50,
            search: '',
            filters: {},
            yukleniyor: true,
            yil: yil ,
            ay: ay,
            temsilci: temsilci ? temsilci : '',
            teklifTipi,
            mal:0,
            hizmet:0,
            teklif: 0,
            yedek_parca: 0,
            sozlesme: 0,
            agir_bakim: 0,
            agir_tamir: 0,
            revizyon_guncelleme: 0
        };
    }

    componentDidMount() {
        this.veriGetir();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.yil !== this.state.yil ||
            prevState.ay !== this.state.ay ||
            prevState.teklifTipi !== this.state.teklifTipi
        ) {
            this.veriGetir();
        }
    }

    veriGetir = () => {
        this.setState({ yukleniyor: true });
        const { yil, ay, temsilci, teklifTipi } = this.state;
        const pageParams = buildPageParams({
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            search: this.state.search,
            filters: this.state.filters,
            sortBy: this.state.sortBy,
            sortDir: this.state.sortDir,
            extra: {
                yil,
                ay: ay || undefined,
                temsilci: temsilci || undefined,
                teklif_tipi: teklifTipi || undefined,
            },
        });

        api
            .get(`/raporlar/teklif-satis`, { params: pageParams })
            .then(res => {
                try {
                    const liste = Array.isArray(res.data.liste) ? res.data.liste : [];
                    const temiz = liste
                        .filter(d => d && typeof d === "object") // null veya bozuk öğeleri at
                        .map(d => ({
                            teklif_no: d?.sgteklifno ?? "",
                            sevk_notlari: d?.sevk_notlari ?? "",
                            teklif_tarihi: d?.teklif_tarihi ?? "",
                            teslim_tarihi: d?.teslim_tarihi ?? "",
                            sevk_tarihi: d?.sevk_tarihi ?? "",
                            musteri: d?.musteri ?? "",
                            lokasyon: d?.lokasyon ?? "",
                            makine: d?.makine ?? "",
                            teklif_tipi: d?.teklif_tipi ?? "",
                            uyf_no: d?.uyf_no ?? "",
                            seri_no: d?.seri_no ?? "",
                            temsilci: d?.temsilci ?? "",
                            dosya_var: d?.dosya_var ?? "",
                            teklif_dili: d?.teklif_dili ?? "",
                            fiyat_euro: d?.toplam_fiyat_euro ? parseFloat(d.toplam_fiyat_euro) : 0
                        }));
                    const tipToplamlari = res.data.tip_toplamlari || {};
                    this.setState({
                        veriler: temiz,
                        count: res.data.count != null ? Number(res.data.count) : temiz.length,
                        yukleniyor: false,
                        mal: res.data.toplamlar.mal,
                        hizmet: res.data.toplamlar.hizmet,
                        teklif: tipToplamlari.teklif || 0,
                        yedek_parca: tipToplamlari.yedek_parca || 0,
                        sozlesme: tipToplamlari.sozlesme || 0,
                        agir_bakim: tipToplamlari.agir_bakim || 0,
                        agir_tamir: tipToplamlari.agir_tamir || 0,
                        revizyon_guncelleme: tipToplamlari.revizyon_guncelleme || 0
                    });

                } catch (mapError) {
                    console.error("Veri map sırasında patladı:", mapError);
                    this.setState({ veriler: [], count: 0, yukleniyor: false });
                }
            })
            .catch(err => {
                console.error("Veri alınamadı:", err.message);
                this.setState({ yukleniyor: false });
            });
    };

    yilDegisti = (e) => {
        this.setState({ yil: e.target.value });
    };
    ayDegisti = (e) => {
        this.setState({ ay: e.target.value });
    };

    sevkiyatNotu = (value, meta) => {
        const record = this.state.veriler[meta.currentTableData[meta.rowIndex].index];
        if (value) {
            return (
                <ModalBoxSevkiyatNotu key={meta.rowIndex} id={record.id} sevk_notu={record.sevk_notlari} />
            );
        }
        return null;
    };

    eklerBodyRender = (value, meta) => {
        const record = this.state.veriler[meta.currentTableData[meta.rowIndex].index];
        if (value) {
            return (
                <ModalboxEkler key={meta.rowIndex} teklifNo={record.teklif_no} dosyaVar={record.dosya_var} />
            );
        }
        return null;
    };

    render() {
        const options = {
            sortOrder: { name: "sevk_tarihi", direction: "desc" },
            filter: true,
            onFilterChange: (changedColumn, filterList) => {
                console.log(changedColumn, filterList);
            },
            selectableRows: 'none',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: this.state.rowsPerPage,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '80%',
            print:false,
            download:true,
            searchOpen:false,
            draggableColumns: {
                enabled:true,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },

            textLabels :{
                body: {
                    noMatch: "Bu tabloda hiç bir veri yok",
                    toolTip: "Sırala",
                    columnHeaderTooltip: column => `${column.label} için sırala`
                },
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Tamamlanan Teklifler Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },
            expandableRows: true,
            // aramanın yanında temizle butonu customSearchRender: Debounce.debounceSearchRender(500),

            renderExpandableRow: (rowData, rowMeta) => {
                const record = this.state.veriler[rowMeta.dataIndex];
                return (
                    <TableRow>
                        <TableCell colSpan={14}>
                            <TeklifSatisRaporuChild rowData={rowData} rowMeta={rowMeta} teklifNo={record?.teklif_no} />
                        </TableCell>
                    </TableRow>
                      );
            },
        };
        const myTheme  = createTheme(adaptV4Theme({
            overrides: {

                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"10px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 1,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:5
                    },
                    root: {
                        lineHeight:1
                    }
                },


            },
        }));
        function kisaltMusteriAdi(ad) {
            const kelimeler = ad.trim().split(" ");
            return kelimeler.slice(0, 2).join(" ");
        }
        const kolonlar = [
            {
                name: "sevk_notlari",
                label: "Sevk Notları",
                options: {
                    filter: false,
                    customBodyRender: (value, meta) => this.sevkiyatNotu(value, meta),
                    sort: false,
                }
            },
            {
                name: "teklif_no",
                label: "Teklif No",
                options: {
                    filter: false,
                    customBodyRender: (value, meta) => {
                        const record = this.state.veriler[meta.currentTableData[meta.rowIndex].index];
                        if (value) {
                            return (
                                <MalzemeListesiOnizleme key={meta.rowIndex} teklifNo={value} teklifDili={record.teklif_dili} teklifTarihi={record.teklif_tarihi} />
                            );
                        }
                    },
                }
            },
            {
                name: "teklif_tarihi",
                label: "Teklif Tarihi",
                options: {
                    filter: false,
                    customBodyRender: (value) => value ? moment(new Date(value)).format('DD/MM/YYYY') : '',
                }
            },
            {
                name: "teslim_tarihi",
                label: "Teslim Tarihi",
                options: {
                    filter: false,
                    customBodyRender: (value) => value ? moment(new Date(value)).format('DD/MM/YYYY') : '',
                }
            },
            {
                name: "sevk_tarihi",
                label: "Sevk Tarihi",
                options: {
                    filter: false,
                    customBodyRender: (value) => value ? moment(new Date(value)).format('DD/MM/YYYY') : '',
                }
            },
            {
                name: "musteri",
                label: "Müşteri",
                options: {
                    filter: true,
                    filterOptions: { fullWidth: true },
                    customBodyRender: (value) => value ? kisaltMusteriAdi(value) : '',
                }
            },
            {
                name: "lokasyon",
                label: "Lokasyon",
                options: { filter: false }
            },
            {
                name: "makine",
                label: "Makine",
                options: { filter: false, sort: false }
            },
            {
                name: "teklif_tipi",
                label: "Teklif Tipi",
                options: {
                    filter: true,
                    filterOptions: { fullWidth: true },
                    customBodyRender: (value) => teklifTipiLabel(value),
                }
            },
            {
                name: "uyf_no",
                label: "UYF No",
                options: {
                    filter: true,
                    filterOptions: { fullWidth: true },
                    sort: false
                }
            },
            {
                name: "seri_no",
                label: "Seri No",
                options: {
                    filter: true,
                    filterOptions: { fullWidth: true },
                    sort: false
                }
            },
            {
                name: "teklif_no",
                label: "Ek",
                options: {
                    filter: false,
                    customBodyRender: (value, meta) => this.eklerBodyRender(value, meta),
                    sort: false,
                }
            },
            {
                name: "temsilci",
                label: "Temsilci",
                options: {
                    filter: true,
                    filterOptions: { fullWidth: true },
                    sort: false
                }
            },
            {
                name: "fiyat_euro",
                label: "Fiyat (€)",
                options: {
                    filter: false,
                    customBodyRender: (value) =>
                        value?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })
                }
            }
        ];

        return (
            <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, mb: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0, flexWrap: 'wrap' }}>
                        <FormControl size="small" sx={{ minWidth: 90 }}>
                            <InputLabel id="demo-simple-select-label">Yıl</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={this.state.yil}
                                label="Yıl"
                                onChange={this.yilDegisti}
                            >
                                {Array.from({ length: new Date().getFullYear() - 2022 + 1 }, (_, i) => {
                                    const year = 2022 + i;
                                    return (
                                        <MenuItem key={year} value={String(year)}>
                                            {year}
                                        </MenuItem>
                                    );
                                })}

                            </Select>
                        </FormControl>
                        <FormControl size="small" sx={{ minWidth: 80 }}>
                            <InputLabel id="demo-simple-select-label">Ay</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={this.state.ay}
                                label="Ay"
                                onChange={this.ayDegisti}
                            >
                                <MenuItem key={""} value={""}>
                                    Tüm Yıl
                                </MenuItem>
                                {Array.from({ length: 12 }, (_, i) => {
                                    const ay = 1 + i;
                                    return (
                                        <MenuItem key={ay} value={String(ay)}>
                                            {ay}
                                        </MenuItem>
                                    );
                                })}

                            </Select>
                        </FormControl>
                        <FormControl size="small" sx={{ minWidth: 140 }}>
                            <InputLabel>Teklif Tipi</InputLabel>
                            <Select
                                value={this.state.teklifTipi}
                                label="Teklif Tipi"
                                onChange={(e) => this.setState({ teklifTipi: e.target.value, page: 0 })}
                            >
                                <MenuItem value="">Tümü</MenuItem>
                                <MenuItem value="teklif">Teklif</MenuItem>
                                <MenuItem value="yedek_parca">Yedek Parça</MenuItem>
                                <MenuItem value="sozlesme">Bakım Sözleşmesi</MenuItem>
                                <MenuItem value="agir_bakim">Ağır Bakım</MenuItem>
                                <MenuItem value="agir_tamir">Ağır Tamir</MenuItem>
                                <MenuItem value="revizyon_guncelleme">Revizyon-Güncelleme</MenuItem>
                            </Select>
                        </FormControl>
                        <Box sx={{ fontSize: 14, whiteSpace: 'nowrap' }}>
                            <strong style={{color:'#f60'}}>Ürün :</strong> {this.state.mal?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                            <strong style={{color:'#f60'}}> Hizmet :</strong> {this.state.hizmet?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                            <strong style={{color:'#f60'}}> Toplam :</strong> {(this.state.hizmet +this.state.mal).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €
                        </Box>
                    </Box>
                    <Box sx={{ textAlign: 'right', fontSize: 13, lineHeight: 1.5, whiteSpace: 'nowrap', flexShrink: 0 }}>
                        <strong style={{color:'#1976d2'}}>Teklif :</strong> {this.state.teklif?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        <strong style={{color:'#9333ea'}}> Yedek Parça :</strong> {this.state.yedek_parca?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        <strong style={{color:'#0f766e'}}> Bakım Sözleşmesi :</strong> {this.state.sozlesme?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        <strong style={{color:'#8d6e63'}}> Ağır Bakım :</strong> {this.state.agir_bakim?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        <strong style={{color:'#dc2626'}}> Ağır Tamir :</strong> {this.state.agir_tamir?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} € |
                        <strong style={{color:'#f59e0b'}}> Revizyon-Güncelleme :</strong> {this.state.revizyon_guncelleme?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} €
                    </Box>
                </Box>

                {this.state.yukleniyor ? (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <ThemeProvider theme={myTheme}>

                    <MUIDataTable
                        title={`Teklif Satış Raporu - ${this.state.yil} / ${this.state.ay} | ${this.state.temsilci}` }
                        data={this.state.veriler}
                        columns={enhanceColumns(kolonlar)}
                        options={withTableOptions(withServerSideOptions(options, {
                            count: this.state.count,
                            page: this.state.page,
                            rowsPerPage: this.state.rowsPerPage,
                            sortBy: this.state.sortBy,
                            sortDir: this.state.sortDir,
                            onServerTableChange: makeServerTableHandler(this, "veriGetir"),
                        }))}
                    />
                    </ThemeProvider>
                )}
            </Box>
        );
    }
}

export default TeklifSatisRaporu;
